import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'ModalBase',
};

import { ref, onMounted } from '@nuxtjs/composition-api';
import ModalCloseButton from './ModalCloseButton.vue';

export interface ModalBaseProps {
  show: boolean;
  heading?: string;
  closeable?: boolean;
}

export interface ModalEmits {
  (event: 'close'): void;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean },
    heading: null,
    closeable: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean;
  heading?: string;
  closeable?: boolean;
};



const close = () => emit('close');
const modalHeading = ref<HTMLHeadingElement | null>(null);

onMounted(() => {
  if (props.heading && modalHeading.value != null) {
    modalHeading.value.focus();
  }
});

return { __sfc: true,props, emit, close, modalHeading, ModalCloseButton }
}

})